import React, { useState } from "react";
import MainLayout1 from "Components/UI/Layout/MainLayout1";

import Paper from "Components/UI/Paper";

import { useNavigate, useLoaderData } from "react-router-dom";
import {
  createEndcustomerAccount as createEndcustomerAccountReq,
  getEndCustomers,
} from "API/swesum";
import usePost from "Hooks/usePost";
import EndcustomerAccountForm from "Components/Account/EndcustomerAccountForm";
import { getAllEndcustomerArticles } from "API/swesum";
import EndcustomerAccountFormSystem from "../../../Components/Account/ClientAccountFormSystem";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Tab, Tabs } from "@mui/material";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const initialState = {
  Amount: 0,
  EndCustomerArticleId: "",
  InvoiceId: "",
  EndCustomerId: "",
  PrintedId: 0,
  BookRefId: 0,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export async function loader() {
  const endcustomerArticles = await getAllEndcustomerArticles();
  const endcustomers = await getEndCustomers();
  return { endcustomerArticles, endcustomers };
}

export default function CreateEndcustomerAccount() {
  const { endcustomerArticles, endcustomers } = useLoaderData();
  const [formData, setFormData] = useState(initialState);
  const { openError } = usePopupNotificationContext();

  const createAccReq = usePost({
    mtnFunc: (body) => createEndcustomerAccountReq(body),
    onError: () => {
      openError("Ett fel uppstod när Kontot skapades.");
    },
    onSuccess: (data) => {
      navigate(`/endcustomersaccounts/${data.Id}`);
      //navigate(`/endcustomersaccounts/`);
    },
  });

  const navigate = useNavigate();

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <MainLayout1>
        <Paper>
          <Typography sx={{ marginBottom: "2rem" }} variant="h5">
            Skapa slutkundskonto
          </Typography>
          <Tabs
            value={tabIndex}
            onChange={handleTabSwitch}
            sx={{ marginBottom: "2rem" }}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Allmänt" />
            <Tab label="System" />
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
            <EndcustomerAccountForm
              formData={formData}
              endcustomers={endcustomers}
              endcustomerArticles={endcustomerArticles}
              handleInputChange={handleInputChange}
            />
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <EndcustomerAccountFormSystem
              formData={formData}
              endcustomerArticles={endcustomerArticles}
              handleInputChange={handleInputChange}
            />
          </TabPanel>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button onClick={() => navigate(-1)}>Stäng</Button>
            <Button
              onClick={() => createAccReq.post(formData)}
              variant="contained"
              sx={{ ml: 3 }}
            >
              Spara
            </Button>
          </Grid>
        </Paper>
      </MainLayout1>
    </>
  );
}
